<template>
  <img
    v-if="fileType === 'IMAGE'"
    :class="customClass"
    loading="lazy"
    :src="config.public.mediaUrl + imageUrl"
    :alt="'file item banner ' + truncateAlt(imageUrl)?.toLowerCase()"
  />

  <video
    v-else-if="fileType === 'VIDEO' && !player"
    width="320"
    height="240"
    autoplay
    muted
    loop
    playsinline
    webkit-playsinline
    :class="customClass"
  >
    <source
      :src="config.public.mediaUrl + imageUrl + '#t=0.001'"
      type="video/mp4"
    />
  </video>
  <video
    v-else-if="fileType === 'VIDEO' && player"
    :key="imageUrl"
    width="320"
    height="240"
    controls
    playsinline
    preload="auto"
    webkit-playsinline
    :class="customClass"
  >
    <source
      :src="config.public.mediaUrl + imageUrl + '#t=0.001'"
      type="video/mp4"
    />
  </video>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  imageUrl: string
  customClass?: string | Record<string, boolean>
  player?: boolean
}>()

const config = useRuntimeConfig()

const extension = computed(() =>
  props.imageUrl?.split('.').pop()?.toLowerCase()
)

const fileType = computed(() => {
  switch (extension.value) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'svg':
      return 'IMAGE'
    case 'mp4':
    case 'm4v':
      return 'VIDEO'
    default:
      return 'UNSUPPORTED'
  }
})

function truncateAlt(alt: string) {
  return alt.length > 80 ? alt.slice(0, 80) + '…' : alt
}
</script>
